function checkIfMinicartLoader() {
    const intervalId = setInterval(function () {
        if (typeof window.SLIDECART_UPDATE !== 'undefined') {
            clearInterval(intervalId);
            const button = document.querySelector('.product-form__submit.button.button--secondary');
            if (button) {
                button.disabled = false;
            }
        }
    }, 100);
}

checkIfMinicartLoader();